module.exports = __webpack_public_path__ + "assets/login-frontend/XING-Sans-Bold-a2d489cb818229a2.woff2";